import { FlowVersion } from "src/api/flowTypes";
import { useAuthoringContext } from "src/router/routerContextHooks";

/**
 * @returns whether the current version has a simulation attached
 */
export const useHasSimulation = () => {
  const { version } = useAuthoringContext();

  return hasSimulation(version);
};

export const hasSimulation = (version: FlowVersion): boolean =>
  !!version.meta?.simulations &&
  Object.values(version.meta.simulations).length > 0;
